export default "__VITE_PUBLIC_ASSET__7d8148ac__"